export { DatePicker } from './datepicker.component';
export { AngularDateTimePickerModule } from './datepicker.module';


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/angular2-datetimepicker/index.ts